import {createContext, useContext, useEffect, useState} from 'react';

interface Context {
  isOffline: boolean;
}

const CONTEXT_STRUCTURE = {
  isOffline: false,
};

// eslint-disable-next-line react-refresh/only-export-components
export const NetworkStatusContext = createContext<Context>(CONTEXT_STRUCTURE);
NetworkStatusContext.displayName = 'Network Status';

// eslint-disable-next-line react-refresh/only-export-components
export const useNetworkStatus = () => useContext(NetworkStatusContext);

export const NetworkStatusProvider = ({children}: {children: React.ReactNode}) => {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setIsOffline(true);
    };

    const handleOnline = () => {
      setIsOffline(false);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  const value = {isOffline};

  return <NetworkStatusContext.Provider value={value}>{children}</NetworkStatusContext.Provider>;
};

export default NetworkStatusProvider;
